(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
/* Refresh compiled assets after theme duplication. */

if (!customElements.get('ess-mobile-nav')) {
  class EssMobileNav extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        if (!this.isConnected || this.controller) return;
        const button = this.querySelector('.ess-navigation__toggle');
        const panel = this.querySelector('.ess-navigation__links');
        if (!button || !panel) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const mobile = matchMedia('(max-width: 749px)');
        const close = () => {
          panel.hidden = mobile.matches;
          button.setAttribute('aria-expanded', 'false');
        };
        button.addEventListener(
          'click',
          () => {
            const expanded = button.getAttribute('aria-expanded') !== 'true';
            button.setAttribute('aria-expanded', String(expanded));
            panel.hidden = !expanded;
          },
          { signal }
        );
        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
              close();
              button.focus();
            }
          },
          { signal }
        );
        document.addEventListener(
          'click',
          (event) => {
            if (mobile.matches && !this.contains(event.target)) close();
          },
          { signal }
        );
        mobile.addEventListener('change', close, { signal });
        this.querySelector('select[name="language_code"]')?.addEventListener(
          'change',
          (event) => {
            event.target.form.requestSubmit();
          },
          { signal }
        );
        close();
        this.classList.add('is-ready');
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = undefined;
    }
  }
  customElements.define('ess-mobile-nav', EssMobileNav);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-felgen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('es-felgen')) return;

    class EsFelgen extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var params = new URLSearchParams(window.location.search);
        var preset = (params.get('option_values') || '').split(',').filter(Boolean).length;
        this.chosen = this.dataset.chosen === 'true' || params.has('variant') || preset >= 2;
        this.showAll = false;
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        var form = this.querySelector('[data-es-fg-form]');
        if (form) form.addEventListener('submit', this.onSubmit.bind(this));
        this.applyState();
        this.watchBar();
      }

      onClick(event) {
        var design = event.target.closest('[data-ov]');
        if (design && this.contains(design)) {
          this.pickDesign(design);
          return;
        }
        var toggle = event.target.closest('[data-es-fg-toggle]');
        if (toggle) {
          this.showAll = toggle.getAttribute('aria-expanded') !== 'true';
          this.applyMore();
          return;
        }
        var thumb = event.target.closest('[data-es-fg-thumb]');
        if (thumb) {
          this.goTo(parseInt(thumb.dataset.esFgThumb, 10) || 0);
          return;
        }
        if (event.target.closest('[data-es-fg-lock]')) {
          event.preventDefault();
          this.needModel();
        }
      }

      onChange(event) {
        var select = event.target.closest('[data-es-fg-model]');
        if (!select || !select.value) return;
        this.chosen = true;
        var active = this.querySelector('.es-fg__d.is-on');
        this.load(select.value, active ? active.dataset.ov : '');
      }

      onSubmit(event) {
        if (!this.chosen) {
          event.preventDefault();
          this.needModel();
        }
      }

      needModel() {
        this.classList.add('is-need');
        var hint = this.querySelector('[data-es-fg-hint]');
        if (hint) hint.hidden = false;
        var select = this.querySelector('[data-es-fg-model]');
        if (select) {
          select.scrollIntoView({ behavior: 'smooth', block: 'center' });
          select.focus({ preventScroll: true });
        }
      }

      pickDesign(button) {
        this.querySelectorAll('.es-fg__d.is-on').forEach(function (b) {
          b.classList.remove('is-on');
          b.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-on');
        button.setAttribute('aria-pressed', 'true');
        var name = button.dataset.name || '';
        var current = this.querySelector('[data-es-fg-dcur]');
        if (current) current.textContent = name;
        var barName = this.querySelector('[data-es-fg-barname]');
        if (barName) barName.textContent = name;
        var first = this.querySelector('[data-es-fg-slide="0"] img');
        if (first && button.dataset.full) {
          first.removeAttribute('srcset');
          first.src = button.dataset.full;
        }
        this.goTo(0);
        var select = this.querySelector('[data-es-fg-model]');
        var model = select && select.value ? select.value : select ? select.dataset.current : '';
        this.load(model, button.dataset.ov);
      }

      load(modelOv, designOv) {
        var self = this;
        var values = [modelOv, designOv].filter(Boolean).join(',');
        var url = this.dataset.url + '?section_id=' + encodeURIComponent(this.dataset.section) + '&option_values=' + values;
        this.classList.add('is-loading');
        if (this._abort) this._abort.abort();
        this._abort = 'AbortController' in window ? new AbortController() : null;
        fetch(url, this._abort ? { signal: this._abort.signal } : {})
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('es-felgen');
            if (!fresh) throw new Error('missing');
            ['[data-es-fg-media]', '[data-es-fg-price]', '[data-es-fg-picker]'].forEach(function (sel) {
              var oldNode = self.querySelector(sel);
              var newNode = fresh.querySelector(sel);
              if (oldNode && newNode) oldNode.replaceWith(newNode);
            });
            self.dataset.variant = fresh.dataset.variant;
            self.dataset.price = fresh.dataset.price;
            self.dataset.design = fresh.dataset.design;
            var input = self.querySelector('[data-es-fg-id]');
            if (input) input.value = fresh.dataset.variant;
            self.applyState();
            if (self.chosen && window.history && window.history.replaceState) {
              window.history.replaceState(window.history.state, '', self.dataset.url + '?variant=' + fresh.dataset.variant);
            }
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            window.location.href = self.dataset.url + '?option_values=' + values;
          })
          .finally(function () {
            self.classList.remove('is-loading');
          });
      }

      applyState() {
        var select = this.querySelector('[data-es-fg-model]');
        if (select && this.chosen && select.dataset.current) {
          select.value = select.dataset.current;
        }
        this.classList.toggle('is-locked', !this.chosen);
        if (this.chosen) {
          this.classList.remove('is-need');
          var hint = this.querySelector('[data-es-fg-hint]');
          if (hint) hint.hidden = true;
        }
        var price = this.dataset.price || '';
        var addPrice = this.querySelector('[data-es-fg-addprice]');
        if (addPrice) addPrice.textContent = price;
        var barPrice = this.querySelector('[data-es-fg-barprice]');
        if (barPrice) barPrice.textContent = price;
        var barName = this.querySelector('[data-es-fg-barname]');
        if (barName && this.dataset.design) barName.textContent = this.dataset.design;
        var more = this.querySelector('[data-es-fg-more]');
        if (more && !more.hidden) this.showAll = true;
        this.applyMore();
        this.bindTrack();
      }

      applyMore() {
        var more = this.querySelector('[data-es-fg-more]');
        var toggle = this.querySelector('[data-es-fg-toggle]');
        if (!more || !toggle) return;
        more.hidden = !this.showAll;
        toggle.setAttribute('aria-expanded', this.showAll ? 'true' : 'false');
        toggle.textContent = this.showAll ? toggle.dataset.less : toggle.dataset.more;
      }

      bindTrack() {
        var track = this.querySelector('[data-es-fg-track]');
        if (!track || track._esBound) return;
        track._esBound = true;
        var self = this;
        var timer;
        track.addEventListener('scroll', function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            self.querySelectorAll('[data-es-fg-thumb]').forEach(function (t) {
              t.classList.toggle('is-on', parseInt(t.dataset.esFgThumb, 10) === index);
            });
          }, 80);
        }, { passive: true });
      }

      goTo(index) {
        var track = this.querySelector('[data-es-fg-track]');
        if (!track) return;
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
        this.querySelectorAll('[data-es-fg-thumb]').forEach(function (t) {
          t.classList.toggle('is-on', parseInt(t.dataset.esFgThumb, 10) === index);
        });
      }

      watchBar() {
        var bar = this.querySelector('[data-es-fg-bar]');
        var add = this.querySelector('[data-es-fg-add]');
        if (!bar || !add || !('IntersectionObserver' in window)) return;
        var self = this;
        var addVisible = true;
        var sectionVisible = true;
        var update = function () {
          var on = !addVisible && sectionVisible;
          bar.classList.toggle('is-on', on);
          bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          var btn = bar.querySelector('button');
          if (btn) btn.tabIndex = on ? 0 : -1;
        };
        new IntersectionObserver(function (entries) {
          addVisible = entries[0].isIntersecting;
          update();
        }).observe(add);
        new IntersectionObserver(function (entries) {
          sectionVisible = entries[0].isIntersecting;
          update();
        }, { rootMargin: '0px 0px -40% 0px' }).observe(self.querySelector('.es-fg__grid') || self);
      }
    }

    customElements.define('es-felgen', EsFelgen);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-galerie"] && !Shopify.designMode) return;
  try {
    
/* Designgalerie (26.10.2026): Modell/Stil/Suche/Sortierung, Abgleich mit echten Produkten über es-design-feed,
   Links je Karte: echtes Produkt → Galerie-Produkt mit ?design= → WhatsApp. Zustand in der URL (replaceState). */
(() => {
  if (!window.customElements || customElements.get('es-galerie')) return;
  const CACHE_MS = 600000;
  const norm = (s) =>
    String(s || '')
      .toUpperCase()
      .replace(/Ü/g, 'UE')
      .replace(/Ö/g, 'OE')
      .replace(/Ä/g, 'AE')
      .replace(/[^A-Z0-9]/g, '');
  const fill = (s, d, m) => String(s || '').split('{d}').join(d).split('{m}').join(m);
  const parse = (s, fallback) => {
    try {
      return JSON.parse(s);
    } catch (error) {
      return fallback;
    }
  };

  class EsGalerie extends HTMLElement {
    connectedCallback() {
      if (this._ok) return;
      this._ok = true;
      this.t = parse(this.dataset.i18n || '[]', []);
      this.alias = parse(this.dataset.alias || '{}', {});
      this.root = this.dataset.root || '';
      this.waBase = this.dataset.wa || 'https://wa.me/4917672421283?text=';
      this.sel = this.querySelector('[data-eg-modell]');
      this.q = this.querySelector('[data-eg-q]');
      this.sortSel = this.querySelector('[data-eg-sort]');
      this.grid = this.querySelector('[data-eg-grid]');
      this.chips = Array.from(this.querySelectorAll('[data-eg-stil]'));
      this.countEl = this.querySelector('[data-eg-count]');
      this.emptyEl = this.querySelector('[data-eg-empty]');
      this.statusEl = this.querySelector('[data-eg-status]');
      this.needEl = this.querySelector('[data-eg-need]');
      this.msgEl = this.querySelector('[data-eg-msg]');
      this.modelBox = this.querySelector('[data-eg-modelbox]');
      if (!this.grid) return;
      this.cards = Array.from(this.grid.querySelectorAll('[data-eg-card]')).map((el) => {
        const id = el.dataset.id || '';
        const name = el.dataset.n || '';
        const a = el.querySelector('a');
        const img = el.querySelector('img');
        return {
          el,
          id,
          name,
          img,
          src0: img ? img.getAttribute('src') || '' : '',
          srcset0: img ? img.getAttribute('srcset') || '' : '',
          imgReal: '',
          key: norm(name),
          keys: [norm(name)].concat(this.alias[id] || []),
          st: el.dataset.st || '',
          gs: ',' + (el.dataset.gs || '') + ',',
          o: Number(el.dataset.o) || 0,
          a,
          b: el.querySelector('[data-eg-badge]'),
          href0: a ? a.getAttribute('href') || '' : '',
          blocked: false,
          mode: 'none',
        };
      });
      this._sortOptions();
      const p = new URLSearchParams(window.location.search);
      const want = (p.get('modell') || '').trim().toLowerCase();
      this.s = { modell: '', stil: p.get('stil') || '', q: (p.get('q') || '').trim(), sort: p.get('sort') === 'az' ? 'az' : '' };
      if (want) {
        if (this._opt(want)) this.s.modell = want;
        else this._msg(this.t[26]);
      }
      if (this.s.stil && !this.chips.some((chip) => chip.dataset.egStil === this.s.stil)) this.s.stil = '';
      if (this.sel) this.sel.value = this.s.modell;
      if (this.q) this.q.value = this.s.q;
      if (this.sortSel) this.sortSel.value = this.s.sort;
      this._bind();
      this._order();
      this._model(false);
    }

    _bind() {
      if (this.sel) {
        this.sel.addEventListener('change', () => {
          this.s.modell = this.sel.value;
          this._msg('');
          this._need(false);
          this._model(true);
        });
      }
      if (this.q) {
        let timer = 0;
        this.q.addEventListener('input', () => {
          window.clearTimeout(timer);
          timer = window.setTimeout(() => {
            this.s.q = this.q.value.trim();
            this._filter();
            this._url();
          }, 150);
        });
        this.q.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.q.blur();
          }
        });
      }
      if (this.sortSel) {
        this.sortSel.addEventListener('change', () => {
          this.s.sort = this.sortSel.value === 'az' ? 'az' : '';
          this._order();
          this._url();
        });
      }
      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          this.s.stil = chip.dataset.egStil || '';
          this._filter();
          this._url();
        });
      });
      this.grid.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const li = target ? target.closest('[data-eg-card]') : null;
        if (!li) return;
        const mode = li.dataset.mode || 'none';
        if (mode === 'none' || mode === 'load') {
          event.preventDefault();
          if (mode === 'none') this._need(true);
        }
      });
    }

    _opt(code) {
      if (!this.sel || !code) return null;
      return Array.from(this.sel.options).find((option) => option.value && option.value === code) || null;
    }

    _sortOptions() {
      if (!this.sel) return;
      const opts = Array.from(this.sel.options).filter((option) => option.value);
      opts.sort((a, b) => a.textContent.trim().localeCompare(b.textContent.trim(), 'de'));
      opts.forEach((option) => this.sel.appendChild(option));
    }

    _model(changed) {
      const o = this._opt(this.s.modell);
      this.m = o
        ? {
            code: o.value,
            name: o.dataset.n || o.textContent.trim(),
            c: o.dataset.c || '',
            cu: o.dataset.cu || '',
            g: o.dataset.g || '',
            vl: o.dataset.vl !== 'false',
          }
        : null;
      this.map = null;
      this.err = false;
      this.loading = false;
      this._tok = (this._tok || 0) + 1;
      if (changed) this._url();
      if (!this.m) {
        this._paint();
        this._filter();
        this._status();
        return;
      }
      this._load(this.m, this._tok);
    }

    async _load(m, token) {
      const key = 'es-galerie2:' + this.root + ':' + m.c;
      let map = null;
      try {
        const cached = JSON.parse(window.sessionStorage.getItem(key) || 'null');
        if (cached && Date.now() - cached.t < CACHE_MS && Array.isArray(cached.m)) map = new Map(cached.m);
      } catch (error) {
        map = null;
      }
      if (!map) {
        this.loading = true;
        this._paint();
        this._filter();
        this._status();
        map = new Map();
        let err = false;
        try {
          let next = this.root + '/collections/' + encodeURIComponent(m.c);
          for (let page = 0; next && page < 8; page++) {
            const url = new URL(next, window.location.origin);
            url.searchParams.set('section_id', 'es-design-feed');
            const response = await fetch(url.toString(), { credentials: 'same-origin' });
            if (!response.ok) throw new Error('HTTP ' + response.status);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const node = doc.querySelector('script[data-es-feed]');
            if (!node) throw new Error('feed');
            const data = JSON.parse(node.textContent);
            (data.products || []).forEach((product) => {
              const k = norm(product.name);
              if (k && product.url && !map.has(k)) map.set(k, { u: product.url, i: product.image_small || '', b: product.image || '' });
            });
            next = data.next || '';
          }
        } catch (error) {
          err = true;
        }
        if (token !== this._tok) return;
        this.loading = false;
        this.err = err;
        if (!err) {
          try {
            window.sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), m: Array.from(map.entries()) }));
          } catch (error) {
            /* Speicher voll oder gesperrt – egal */
          }
        }
      }
      if (token !== this._tok) return;
      this.map = map;
      this._paint();
      this._filter();
      this._status();
    }

    _paint() {
      const m = this.m;
      const t = this.t;
      this.cards.forEach((c) => {
        let mode = 'none';
        let href = c.href0;
        let ext = false;
        let label = t[14] || '';
        let realImg = null;
        c.blocked = !!(m && c.gs.indexOf(',' + m.code + ',') !== -1);
        if (m) {
          const real = this.map ? c.keys.map((k) => this.map.get(k)).find((v) => v && v.u) : null;
          if (real) {
            mode = 'real';
            href = real.u;
            label = t[11] || '';
            realImg = real.i ? real : null;
          } else if (!this.map) {
            mode = 'load';
            label = '…';
          } else if (m.g) {
            mode = 'gal';
            href = this.root + '/products/' + m.g + '?design=' + encodeURIComponent(c.id);
            label = t[12] || '';
          } else {
            mode = 'wa';
            href = this.waBase + encodeURIComponent(fill(t[18], c.name, m.name));
            ext = true;
            label = t[13] || '';
          }
        }
        c.mode = mode;
        c.el.dataset.mode = mode;
        if (c.a) {
          c.a.setAttribute('href', href);
          if (ext) {
            c.a.setAttribute('target', '_blank');
            c.a.setAttribute('rel', 'noopener');
          } else {
            c.a.removeAttribute('target');
            c.a.removeAttribute('rel');
          }
        }
        if (c.b) c.b.textContent = label;
        /* Echtes Produkt für dieses Modell: dessen Shopbild zeigen (sonst Bild des Beispielprodukts) */
        if (c.img) {
          const want = realImg ? realImg.i : '';
          if (want !== c.imgReal) {
            c.imgReal = want;
            if (realImg) {
              c.img.setAttribute('srcset', realImg.i + ' 360w' + (realImg.b ? ', ' + realImg.b + ' 900w' : ''));
              c.img.setAttribute('src', realImg.i);
            } else {
              if (c.srcset0) c.img.setAttribute('srcset', c.srcset0);
              else c.img.removeAttribute('srcset');
              c.img.setAttribute('src', c.src0);
            }
          }
        }
      });
    }

    _filter() {
      const q = norm(this.s.q);
      const st = this.s.stil;
      let n = 0;
      this.cards.forEach((c) => {
        const show = !c.blocked && (!st || c.st.indexOf('|' + st + '|') !== -1) && (!q || c.key.indexOf(q) !== -1);
        c.el.hidden = !show;
        if (show) n++;
      });
      this.chips.forEach((chip) => {
        const on = (chip.dataset.egStil || '') === st;
        chip.classList.toggle('is-on', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (this.countEl) this.countEl.textContent = String(n);
      if (this.emptyEl) this.emptyEl.hidden = n !== 0;
    }

    _order() {
      const list = this.cards.slice();
      if (this.s.sort === 'az') list.sort((a, b) => a.name.localeCompare(b.name, 'de'));
      else list.sort((a, b) => a.o - b.o);
      const frag = document.createDocumentFragment();
      list.forEach((c) => frag.appendChild(c.el));
      this.grid.appendChild(frag);
    }

    _status() {
      const box = this.statusEl;
      if (!box) return;
      const m = this.m;
      box.hidden = !m;
      if (!m) return;
      const t = this.t;
      const name = box.querySelector('[data-eg-mname]');
      const link = box.querySelector('[data-eg-mlink]');
      const sum = box.querySelector('[data-eg-sum]');
      const note = box.querySelector('[data-eg-note]');
      const err = box.querySelector('[data-eg-err]');
      if (name) name.textContent = m.name;
      if (link) link.setAttribute('href', m.cu || this.root + '/collections/' + m.c);
      if (note) note.hidden = !(m.g && !m.vl);
      if (err) err.hidden = !this.err;
      if (!sum) return;
      if (this.loading || !this.map) {
        sum.textContent = t[16] || '';
        return;
      }
      const count = { real: 0, gal: 0, wa: 0 };
      this.cards.forEach((c) => {
        if (!c.blocked && c.mode in count) count[c.mode]++;
      });
      const parts = [count.real + ' ' + (t[19] || '')];
      if (count.gal) parts.push(count.gal + ' ' + (t[20] || ''));
      if (count.wa) parts.push(count.wa + ' ' + (t[21] || ''));
      sum.textContent = parts.join(' · ');
    }

    _need(on) {
      if (this.modelBox) this.modelBox.classList.toggle('is-need', on);
      if (this.needEl) this.needEl.hidden = !on;
      if (!on || !this.sel) return;
      const rect = this.sel.getBoundingClientRect();
      if (rect.top < 80 || rect.bottom > window.innerHeight - 40) this.sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try {
        this.sel.focus({ preventScroll: true });
      } catch (error) {
        /* egal */
      }
    }

    _msg(text) {
      if (!this.msgEl) return;
      this.msgEl.textContent = text || '';
      this.msgEl.hidden = !text;
    }

    _url() {
      try {
        const url = new URL(window.location.href);
        const set = (k, v) => {
          if (v) url.searchParams.set(k, v);
          else url.searchParams.delete(k);
        };
        set('modell', this.s.modell);
        set('stil', this.s.stil);
        set('q', this.s.q);
        set('sort', this.s.sort);
        if (url.toString() !== window.location.href) window.history.replaceState(window.history.state, '', url.toString());
      } catch (error) {
        /* egal */
      }
    }
  }

  customElements.define('es-galerie', EsGalerie);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
/* Refresh compiled assets after theme duplication. */

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protection-configurator"] && !Shopify.designMode) return;
  try {
    
/* Refresh compiled assets after theme duplication. */

if (!customElements.get('escooter-protection')) {
  class ProtectionConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.chosen = new Set(); this.bundle = false; this.busy = false;
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency:this.config.currency || 'EUR'});
      this.syncVariants(this.config.product);
      this.addEventListener('click', e => this.handleClick(e), {signal:this.abort.signal});
      this.addEventListener('keydown', e => {
        const area=e.target.closest('g[data-area]');
        if(area && (e.key === 'Enter' || e.key === ' ')){e.preventDefault();this.toggle(area.dataset.area,'keyboard');}
      }, {signal:this.abort.signal});
      document.addEventListener('visitorConsentCollected',()=>this.trackView(),{signal:this.abort.signal});
      this.render(); this.trackView();
      this.observer=new IntersectionObserver(entries=>{if(entries.some(x=>x.isIntersecting)){if(this.track('complete_set_view'))this.observer.disconnect();}},{threshold:.5});
      this.mobileObserver=new IntersectionObserver(entries=>{this.$('[data-mobilebar]').hidden=!entries[0].isIntersecting;});this.mobileObserver.observe(this);
      this.observer.observe(this.querySelector('.pf-bundle'));
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.mobileObserver?.disconnect();this.ready=false;}
    $(q){return this.querySelector(q);}
    text(k,values={}){return Object.entries(values).reduce((s,[a,b])=>s.replaceAll('{'+a+'}',b),this.config.text[k] || k);}
    money(n){return this.format.format(n/100);}
    syncVariants(product){
      const variants=product?.variants || [];
      this.product=product;
      this.groups=this.config.groups.map(g=>{const v=variants.find(v=>v.sku===g.sku);return {...g,variant:v,price:v ? v.price : g.price};});
      this.complete=variants.find(v=>v.sku===this.config.completeSku);
      this.completePrice=this.complete?.price ?? this.config.completePrice;
    }
    selected(){return this.groups.filter(g=>this.chosen.has(g.id));}
    total(){return this.bundle ? this.completePrice : this.selected().reduce((n,g)=>n+g.price,0);}
    canBuy(){return this.config.release && (this.bundle ? !!this.complete?.available : this.selected().length>0 && this.selected().every(g=>g.variant?.available));}
    track(name,extra={}){
      if(!this.config.release || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true) return false;
      const data={model:this.config.model,areas:[...this.chosen],selection_count:this.chosen.size,mode:this.bundle?'complete':'partial',value:this.total()/100,currency:this.config.currency,...extra};
      try{window.Shopify?.analytics?.publish?.('escooterskins:'+name,data);return !!window.Shopify?.analytics?.publish;}catch{return false;}
    }
    trackView(){if(!this.viewTracked)this.viewTracked=this.track('page_view_schutzfolie');}
    handleClick(e){
      if(this.busy)return;
      if(e.target.closest('[data-jump]')){this.$('.pf-summary').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});return;}
      const area=e.target.closest('[data-area]');
      if(area){this.toggle(area.dataset.area,area.tagName.toLowerCase()==='g'?'hotspot':'list');return;}
      const remove=e.target.closest('[data-remove]');if(remove){this.toggle(remove.dataset.remove,'summary');return;}
      const view=e.target.closest('[data-view]');if(view){this.setView(view.dataset.view);return;}
      if(e.target.closest('[data-bundle]')){
        const countBefore=this.chosen.size;
        this.bundle=!this.bundle;
        this.chosen=new Set(this.bundle?this.groups.map(g=>g.id):[]);
        this.track('complete_set_select',{previous_selection_count:countBefore});this.render();return;
      }
      if(e.target.closest('[data-reset]')){for(const id of this.chosen)this.track('hotspot_deselect',{area:id,source:'reset'});this.chosen.clear();this.bundle=false;this.render();return;}
      if(e.target.closest('[data-add]'))this.add();
    }
    setView(view){for(const p of this.querySelectorAll('[data-panel]'))p.hidden=p.dataset.panel!==view;for(const b of this.querySelectorAll('[data-view]'))b.setAttribute('aria-pressed',String(b.dataset.view===view));}
    toggle(id,source){
      const g=this.groups.find(x=>x.id===id);if(!g || this.busy || (this.config.release && !g.variant?.available))return;
      if(source==='hotspot')this.track('hotspot_click',{area:id});
      this.bundle=false;
      this.chosen.has(id)?this.chosen.delete(id):this.chosen.add(id);
      this.track(this.chosen.has(id)?'hotspot_select':'hotspot_deselect',{area:id,source});
      this.$('[data-tip]').textContent=this.text('tip',{name:g.name,type:g.type,forms:g.forms,price:this.money(g.price)});
      if(source==='list')this.setView(g.view);
      this.render();
    }
    render(){
      for(const el of this.querySelectorAll('[data-area]')){
        const g=this.groups.find(g=>g.id===el.dataset.area);
        el.setAttribute('aria-pressed',String(this.chosen.has(g.id)));
        el.setAttribute('aria-disabled',String(this.busy || (this.config.release && !g.variant?.available)));
        if(el.tagName==='BUTTON')el.disabled=this.busy || (this.config.release && !g.variant?.available);
      }
      for(const g of this.groups)this.querySelector('[data-price-for="'+g.id+'"]').textContent=this.money(g.price);
      const selected=this.selected();
      const pieces=selected.reduce((s,g)=>s+g.forms.split(',').filter(x=>x.trim()).length,0);
      this.$('[data-count]').textContent=this.bundle?this.text('complete_count'):selected.length?this.text('count',{n:selected.length,p:pieces}):this.text('empty');
      const list=this.$('[data-selection]');list.replaceChildren();
      for(const g of selected){const li=document.createElement('li'),label=document.createElement('span'),small=document.createElement('small'),button=document.createElement('button');label.textContent=g.name;small.textContent=g.type+' · '+g.forms;label.append(small);button.type='button';button.textContent='×';button.dataset.remove=g.id;button.disabled=this.busy;button.setAttribute('aria-label',g.name+' – '+this.text('remove'));li.append(label,button);list.append(li);}
      this.$('[data-total]').textContent=this.money(this.total());this.$('[data-mobile-total]').textContent=this.money(this.total());
      this.$('[data-bundle-price]').textContent=this.money(this.completePrice);
      const all=this.groups.reduce((n,g)=>n+g.price,0), saving=all-this.completePrice;
      this.$('[data-compare]').textContent=this.text('compare',{s:this.money(all)});
      this.$('[data-saving]').textContent=saving>0?this.text('saved',{s:this.money(saving)}):'';
      const advice=this.$('[data-advice]'),diff=this.total()-this.completePrice;
      advice.hidden=this.bundle || selected.length===0 || (diff<0 && -diff>100);
      advice.textContent=diff>0?this.text('advice_save',{s:this.money(diff)}):this.text('advice_more',{s:this.money(-diff)});
      const add=this.$('[data-add]');add.disabled=this.busy || !this.canBuy();
      add.textContent=this.busy?this.text('busy'):!selected.length?this.text('choose_first'):!this.config.release?this.text('preview_add'):!this.canBuy()?this.text('unavailable'):this.text('add');
      const bundle=this.$('[data-bundle]');bundle.setAttribute('aria-pressed',String(this.bundle));bundle.textContent=this.bundle?this.text('complete_active'):this.text('choose_complete')+' →';bundle.disabled=this.busy || (this.config.release && !this.complete?.available);
      this.$('[data-reset]').disabled=this.busy || !selected.length;
    }
    async add(){
      if(this.busy || !this.canBuy())return;
      this.busy=true;this.$('[data-message]').textContent='';this.render();
      const root=window.Shopify?.routes?.root || '/';
      try{
        const old=this.total();
        if(this.product?.handle){const r=await fetch(root+'products/'+encodeURIComponent(this.product.handle)+'.js',{headers:{Accept:'application/json'}});if(!r.ok)throw Error('product');this.syncVariants(await r.json());if(!this.canBuy())throw Error('unavailable');if(old!==this.total()){this.$('[data-message]').textContent=this.text('price_changed');return;}}
        const items=this.bundle?[{id:this.complete.id,quantity:1,properties:{Modell:this.config.model,Lieferumfang:'Alle 25 Folienteile',_schutzfolie:'complete'}}]:this.selected().map(g=>({id:g.variant.id,quantity:1,properties:{Modell:this.config.model,Lieferumfang:g.type,Formnummern:g.forms,_schutzfolie:'partial'}}));
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result=await response.json();if(!response.ok || !result.items)throw Error('cart');
        this.track(this.bundle?'complete_set_add':'partial_set_add',{items:items.map(x=>({id:x.id,quantity:1}))});this.track('add_to_cart',{items:items.map(x=>({id:x.id,quantity:1}))});
        this.$('[data-message]').textContent=this.text('success');this.$('[data-cart-link]').hidden=false;
        window.location.assign(root+'cart');
      }catch(error){this.$('[data-message]').textContent=error.message==='unavailable'?this.text('unavailable'):this.text('error');this.$('[data-cart-link]').hidden=false;}
      finally{this.busy=false;this.render();}
    }
  }
  customElements.define('escooter-protection',ProtectionConfigurator);
}


  } catch(e) { console.error(e); }
})();
})();
